import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const MapContainer = styled.div`
	width: 100%;
	height: 100%;
	position: relative;
	input,
	.disabled-view-field {
		width: 30%;
		margin: 0 var(--margin-1);
		@media ${Breakpoints.tablet} {
			width: 60%;
		}
	}
`;
